import { Navigate, Outlet } from "react-router-dom";
import { usePhysicianAuthStore } from "@/stores/physicianAuthStore";
import { usePhysicianSocket } from "@/lib/physicianSocket";
import { useIdleLogout } from "@/portals/physician/hooks/useIdleLogout";
import { PageSpinner } from "@/shared/components/spinner";
import { QueryCacheProvider } from "@/shared/hooks/useCachedQuery";
import { PhysicianLayout } from "./PhysicianLayout";

function SessionLoader() {
  return (
    <div className="bg-white">
      <PageSpinner fullScreen />
    </div>
  );
}

export function PhysicianProtectedLayout() {
  const isAuthenticated = usePhysicianAuthStore((s) => s.isAuthenticated);
  const isLoading = usePhysicianAuthStore((s) => s.isLoading);
  useIdleLogout();
  usePhysicianSocket();

  if (isLoading) return <SessionLoader />;
  if (!isAuthenticated) return <Navigate to="/physician/login" replace />;

  // Screen-data cache for this session only — unmounted (and emptied) on logout.
  return (
    <QueryCacheProvider>
      <PhysicianLayout>
        <Outlet />
      </PhysicianLayout>
    </QueryCacheProvider>
  );
}
